var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAccountApple = function SvgIconAccountApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.813 6.915c-.415.488-1.11.854-1.665.854a.917.917 0 0 1-.164-.015 1.023 1.023 0 0 1-.023-.214c0-.625.32-1.235.672-1.625.445-.51 1.187-.892 1.805-.915.015.069.023.153.023.236 0 .618-.274 1.236-.649 1.679Zm-2.718 9.858c-.278.116-.542.227-.9.227-.765 0-1.297-.687-1.906-1.526C7.58 14.482 7 12.95 7 11.5c0-2.335 1.555-3.57 3.086-3.57.447 0 .855.16 1.218.302.291.114.553.216.782.216.199 0 .447-.095.735-.207.404-.156.887-.342 1.429-.342.344 0 1.602.03 2.43 1.19l-.03.02c-.204.131-1.29.832-1.29 2.269 0 1.777 1.585 2.41 1.64 2.426l-.01.028c-.052.158-.3.909-.834 1.673-.523.732-1.078 1.48-1.906 1.48-.408 0-.668-.113-.937-.229-.286-.124-.583-.252-1.079-.252-.498 0-.828.138-1.139.269Z",
    fill: "#fff"
  })));
};
export default SvgIconAccountApple;